import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ApiService } from './api.service';
import { Http } from '@angular/http';

@Injectable()
export class CheckrService {
  checkrLink = environment.checkrLink;
  usersLink = environment.usersLink;
  apiService: ApiService = new ApiService(this.http);

  constructor(
    private http: Http
  ) { }
  public ssn_trace = {
    "id": "539fd88c101897f7cd000001",
    "object": "ssn_trace",
    "uri": "/v1/ssn_traces/539fd88c101897f7cd000001",
    "status": "clear",
    "created_at": "2014-01-18T12:34:00Z",
    "completed_at": "2014-01-18T12:35:30Z",
    "turnaround_time": 90,
    "ssn": "XXX-XX-4645",
    "addresses": [
      {
        "street": "123 S Folsom St",
        "unit": "Apt 54B",
        "city": "San Francisco",
        "state": "CA",
        "zipcode": "94110",
        "county": "SAN FRANCISCO",
        "from_date": "2010-05-01",
        "to_date": "2014-06-01"
      },
      {
        "street": "1230 5th Avenue",
        "unit": null,
        "city": "New York",
        "state": "NY",
        "zipcode": "1005",
        "county": "NEW YORK",
        "from_date": "2007-07-01",
        "to_date": "2010-05-01"
      }
    ],
    "aliases": [
      {
        "first_name": "Jack",
        "middle_name": "B",
        "last_name": "Fieldman"
      }
    ]
  }

  public sex_offender_search = {
    "id": "539fd88c101897f7cd000008",
    "object": "sex_offender_search",
    "uri": "/v1/sex_offender_searches/539fd88c101897f7cd000008",
    "status": "consider",
    "created_at": "2014-01-18T12:34:00Z",
    "completed_at": "2014-01-18T12:35:30Z",
    "turnaround_time": 90,
    "records": [
      {
        "registry": "California",
        "full_name": "John Alfred Smith",
        "age": 44,
        "dob": "1971-04-11",
        "registration_start": "2011-02-12",
        "registration_end": "life registration"
      }
    ]
  }

  public global_watchlist_search = {
    "id": "539fd88c101897f7cd000008",
    "object": "global_watchlist_search",
    "uri": "/v1/global_watchlist_searches/539fd88c101897f7cd000008",
    "status": "consider",
    "created_at": "2014-01-18T12:34:00Z",
    "completed_at": "2014-01-18T12:35:30Z",
    "turnaround_time": 90,
    "records": [
      {
        "case_number": "24323-DA",
        "file_date": null,
        "arresting_agency": "DEA Boston Division",
        "court_jurisdiction": null,
        "court_of_record": null,
        "dob": "1970-01-22",
        "full_name": "John Alfred Smith",
        "charges": [
          {
            "charge": "RICO murder",
            "charge_type": null,
            "charge_id": null,
            "classification": "Felony",
            "deposition": null,
            "defendant": null,
            "plaintiff": null,
            "sentence": "Active Punishment Minimum: 10Y",
            "disposition": "Guilty",
            "probation_status": null,
            "offense_date": "2011-04-22",
            "deposition_date": "2014-05-27",
            "arrest_date": null,
            "charge_date": null,
            "sentence_date": null,
            "disposition_date": "2011-06-02"
          }
        ]
      }
    ]
  }

  public national_criminal_search = {
    "id": "539fd88c101897f7cd000006",
    "object": "national_criminal_search",
    "uri": "/v1/national_criminal_searches/539fd88c101897f7cd000006",
    "status": "clear",
    "created_at": "2014-01-18T12:34:00Z",
    "completed_at": "2014-01-18T12:35:30Z",
    "turnaround_time": 90,
    "records": [
      {
        "case_number": "24323-DA",
        "file_date": null,
        "arresting_agency": null,
        "court_jurisdiction": null,
        "court_of_record": null,
        "dob": "1970-01-22",
        "full_name": "John Alfred Smith",
        "charges": []
      }
    ]
  }

  public county_criminal_search = {
    "id": "539fdcf335644a0ef4000001",
    "object": "county_criminal_search",
    "uri": "/v1/county_criminal_searches/539fdcf335644a0ef4000001",
    "status": "consider",
    "created_at": "2014-01-18T12:34:00Z",
    "completed_at": "2014-01-18T12:35:30Z",
    "turnaround_time": 100800,
    "county": "SAN FRANCISCO",
    "state": "CA",
    "records": [
      {
        "case_number": "24323-DA",
        "file_date": "2010-02-18",
        "arresting_agency": "San Francisco Police Department",
        "court_jurisdiction": "San Francisco",
        "court_of_record": null,
        "dob": "1970-01-22",
        "full_name": "John Alfred Smith",
        "charges": [
          {
            "charge": "Sell Cocaine",
            "charge_type": null,
            "charge_id": null,
            "classification": "Felony",
            "deposition": null,
            "defendant": "John Alfred Smith",
            "plaintiff": null,
            "sentence": "Active Punishment Minimum: 10M",
            "disposition": "Guilty",
            "probation_status": null,
            "offense_date": "2011-04-22",
            "deposition_date": "2014-05-27",
            "arrest_date": "2011-04-22",
            "charge_date": null,
            "sentence_date": "2011-06-02",
            "disposition_date": "2011-06-02"
          }
        ]
      }
    ]
  }

  public state_criminal_search = {
    "id": "539fdcf335644a0ef4000001",
    "object": "state_criminal_search",
    "uri": "/v1/state_criminal_searches/539fdcf335644a0ef4000001",
    "status": "consider",
    "created_at": "2014-01-18T12:34:00Z",
    "completed_at": "2014-01-18T12:35:30Z",
    "turnaround_time": 100800,
    "state": "CA",
    "records": [
      {
        "case_number": "24323-DA",
        "file_date": "2010-02-18",
        "arresting_agency": "San Francisco Police Department",
        "court_jurisdiction": "San Francisco",
        "court_of_record": null,
        "dob": "1970-01-22",
        "full_name": "John Alfred Smith",
        "charges": [
          {
            "charge": "Sell Cocaine",
            "charge_type": null,
            "charge_id": null,
            "classification": "Felony",
            "deposition": null,
            "defendant": "John Alfred Smith",
            "plaintiff": null,
            "sentence": "Active Punishment Minimum: 10M",
            "disposition": "Guilty",
            "probation_status": null,
            "offense_date": "2011-04-22",
            "deposition_date": "2014-05-27",
            "arrest_date": "2011-04-22",
            "charge_date": null,
            "sentence_date": "2011-06-02",
            "disposition_date": "2011-06-02"
          }
        ]
      }
    ]
  }

  public motor_vehicle_report = {
    "id": "539fd88c101897f7cd000007",
    "object": "motor_vehicle_report",
    "uri": "/v1/motor_vehicle_reports/539fd88c101897f7cd000007",
    "status": "consider",
    "created_at": "2014-01-18T12:34:00Z",
    "completed_at": "2014-01-18T12:35:30Z",
    "turnaround_time": 90,
    "full_name": "John Alfred Smith",
    "license_number": "F2111132",
    "license_state": "CA",
    "license_status": "valid",
    "license_type": "non-commercial",
    "license_class": "C",
    "dob": "1980-01-01",
    "expiration_date": "2016-07-24",
    "issued_date": "2006-12-03",
    "first_issued_date": "2000-01-14",
    "inferred_issued_date": null,
    "restrictions": [],
    "accidents": [
      {
        "accident_date": "2009-04-12",
        "description": "property damage",
        "city": null,
        "county": "SAN FRANCISCO",
        "state": null,
        "order_number": "33-435932",
        "points": null,
        "vehicle_speed": null,
        "reinstatement_date": null,
        "action_taken": "police report filed",
        "ticket_number": null,
        "enforcing_agency": "San Francisco PD",
        "jurisdiction": null,
        "severity": null,
        "violation_number": null,
        "license_plate": "6UM6938",
        "fine_amount": null,
        "state_code": null,
        "acd_code": null,
        "injury_accident": false,
        "fatality_accident": false,
        "fatality_count": 0,
        "injury_count": 0,
        "vehicles_involved_count": 1,
        "report_number": null,
        "policy_number": null
      }
    ],
    "violations": [
      {
        "type": "conviction",
        "issued_date": "2011-11-14",
        "conviction_date": "2010-04-11",
        "description": "speeding 15-19 mph",
        "points": 0,
        "city": null,
        "county": "SANTA CLARA",
        "state": "California",
        "ticket_number": "2D55555",
        "disposition": null,
        "category": null,
        "court_name": null,
        "acd_code": null,
        "state_code": null,
        "docket": null
      }
    ]
  }

  public educational_verification = {
    "id": "595511af261066005170f471",
    "object": "education_verification",
    "uri": "/v1/education_verifications/595511af261066005170f471",
    "completed_at": "2017-07-06T14:15:27Z",
    "created_at": "2017-06-29T14:41:51Z",
    "records": [
      {
        "id": "592311d2113adf7e9c9f66b8",
        "result": {
          "verified": false
        },
        "school": {
          "candidate_id": "762781cdd1c7fd620e956583",
          "id": "95a95172bb81143ed44e403c",
          "uri": "/v1/candidates/762781cdd1c7fd620e956583/schools/95a95172bb81143ed44e403c",
          "name": "College University",
          "address": {
            "street": "1 Circle Avenue",
            "city": "San Francisco",
            "zipcode": "94105",
            "state": "CA",
            "country": "US"
          },
          "degree": "MS",
          "year_awarded": 2017,
          "major": "Computer Science",
          "phone": "415-111-1111",
          "minor": "Background Checks",
          "start_date": "2013-08-25",
          "end_date": "2017-05-10",
          "current": false,
          "object": "school"
        },
        "events": [
          {
            "text": "started",
            "created_at": "2017-06-29T14:42:47Z",
            "type": "verification_start"
          }
        ],
        "status": "consider"
      }
    ],
    "status": "consider",
    "turnaround_time": 603216
  }

  public employment_verification = {
    "id": "595511af261066005170f471",
    "object": "employment_verification",
    "uri": "/v1/employment_verifications/595511af261066005170f471",
    "completed_at": "2017-07-06T14:15:27Z",
    "created_at": "2017-06-29T14:41:51Z",
    "records": [
      {
        "id": "592311d2113adf7e9c9f66b8",
        "result": {
          "start_date": {
            "verified": true,
            "comments": "2016-06-01",
            "ignored": null
          },
          "end_date": {
            "verified": true,
            "comments": "2017-05-01",
            "ignored": null
          },
          "position": {
            "verified": false,
            "comments": "Software Development Engineer",
            "ignored": "manual"
          },
          "contract_type": {
            "verified": true,
            "comments": "Full Time",
            "ignored": "package"
          },
          "salary": {
            "verified": false,
            "comments": "100000",
            "ignored": null
          }
        },
        "employer": {
          "id": "ca27df84be5b50dfa7ee1cda",
          "object": "test_employer",
          "uri": "/v1/candidates/e44aa283528e6fde7d542194/employers/ca27df84be5b50dfa7ee1cda",
          "candidate_id": "e44aa283528e6fde7d542194",
          "name": "Checkr",
          "position": "Software Engineer",
          "salary": 10000,
          "contract_type": "full_time",
          "do_not_contact": false,
          "start_date": "2016-06-01",
          "end_date": "2017-05-01",
          "address": {
            "street": "123 Main St.",
            "city": "San Francisco",
            "state": "CA",
            "zipcode": "94108",
            "country": "US"
          },
          "manager": {
            "email": "joesmith@checkr.com",
            "name": "Joe Smith",
            "phone": "212-555-1234",
            "title": "Engineering Manager"
          }
        },
        "events": [
          {
            "text": "started",
            "created_at": "2017-06-29T14:42:44Z",
            "type": "verification_start"
          }
        ],
        "status": "consider"
      }
    ],
    "status": "consider",
    "turnaround_time": 603216
  }

  public checkr_screens = [
    this.ssn_trace,
    this.sex_offender_search,
    this.global_watchlist_search,
    this.national_criminal_search,
    this.county_criminal_search,
    this.state_criminal_search,
    this.motor_vehicle_report,
    this.educational_verification,
    this.employment_verification
  ]

  public checkrPackages = [
    {code: 'ssn_trace', name: 'SSN Trace', data: null},
    {code: 'motor_vehicle_report', name: 'Motor Vehicle Report', data: null},
    {code: 'sex_offender_search', name: 'Sex Offender Search', data: null},
    {code: 'global_watchlist_search', name: 'Global Watchlist Search', data: null},
    {code: 'national_criminal_search', name: 'National Criminal Search', data: null},
    {code: 'federal_criminal_search', name: 'Federal Criminal Search', data: null},
    {code: 'federal_civil_search', name: 'Federal Civil Search', data: null},
    {code: 'county_criminal_search', name: 'County Criminal Search', data: null},
    {code: 'county_civil_search', name: 'County Civil Search', data: null},
    {code: 'eviction_search', name: 'Eviction Search', data: null},
    {code: 'employment_verification', name: 'Employment Verification', data: null},
    {code: 'education_verification', name: 'Education Verification', data: null},
    {code: 'drug_screening', name: 'drug Screening', data: null}
  ]
  getCheckrCall() {
    return this.checkr_screens
  }
 
  getAllPackages() {
    return this.checkrPackages
  }
  postCheckr(userId, data) {
    return this.apiService.postCall('checkrLink', `background/${userId}`,data);
  }

  getChekr(id) {
    return this.apiService.getCall('checkrLink', `background/report/${id}`);
  }

  getcheckrPackages() {
    return this.apiService.getCall('checkrLink', 'background/packages');
  }
}


// WEBPACK FOOTER //
// ./src/app/main/shared/services/checkr.service.ts